//
//
//
//
//
//
//
//

export default {
    id: 21,
    version: '3.8.8',
    date: '2023-07-14',
    notify: true,
}
